export default {
  // Home page
  jetlympic: {
    entrance: {
      text_1: 'Opening and Closing Ceremonies',
      text_2: 'Jetlympic Competitions',
    },
    home: {
      home_item_1: 'MINI Marathon Living',
      home_item_2: 'Accommodation & Catering',
      home_item_3: 'Schedule',
      home_item_4: 'Shuttle Bus',
      home_item_5: 'Live Stream',
      home_item_6: 'Live Photo',
      home_item_7: 'Regulations',
      home_item_8: 'News',
      home_item_9: 'Event Data'
    },
    list: {
      list_item_1: 'MINI Marathon',
      list_item_6: 'Relay Race',
      list_item_2: 'Basketball',
      list_item_3: 'Soccer',
      list_item_4: 'Badminton',
      list_item_5: 'Table Tennis'
    },
    hotel: {
      hotel_item_1: 'Holiday Inn Shanghai Pudong Kanggiao',
      hotel_item_2: 'Sheraton Shanghai Wanxin <span style="font-size: 14px;">(xiuyan Road MetroStation Branch)</span>',
      hotel_item_3: 'Vienna Hotel <span style="font-size: 14px;">(Xiasha Metro Station Branch)</span>',
      hotel_item_4: 'Shanghai Pudong Lichenghuating Hotel',
      hotel_item_5: 'Orange Hotel <span style="font-size: 14px;">(Shenjiang South Road Branch)</span>',
      hotel_item_6: 'Shanghai Lu\'an Garden Hotel <span style="font-size: 14px;">(Disney Branch)</span>',
      hotel_item_7: 'MiYi Hote <span style="font-size: 14px;">(Shanghai Kanggiao Metro Station Branch)</span>'
    },
    shuttle: {
      text_1: 'Line 1',
      text_2: 'Line 2',
      text_3: 'Line 3',
    },
    video: {
      title_1: '2025 4th Jetlympic Opening Ceremony',
      title_2: '2025 4th Jetlympic Closing Ceremony',
      title_3: '2025 4th Jetlympic MINI Marathon Live',
    },
    sportType: {
      "全部": "All",
      "篮球": "Basketball",
      "足球": "Soccer",
      "羽毛球": "Badminton",
      "乒乓球": "Table Tennis"
    }
  },
  /** OSTASIENSPIELE SHANGHAI activity landing */
  osten: {
    home: {
      title_line1: 'OSTASIENSPIELE SHANGHAI',
      title_line2: '2026',
      closing_ceremony: 'Closing Ceremony',
      sport_gymnastics: 'Gymnastics',
      sport_basketball: 'Basketball',
      sport_football: 'Football',
      sport_swimming: 'Swimming',
      sport_athletics: 'T&F',
      sport_volleyball: 'Volleyball',
      partners_title: 'Partners',
      footer: 'POWERED BY BMBSports'
    },
    subSelect: {
      gymnastics_apr14: 'Tuesday, April 14, 2026',
      gymnastics_apr17: 'Friday, April 17, 2026',
      basketball_women: "Women's Basketball",
      basketball_men: "Men's Basketball",
      football_women: "Women's Football",
      football_men: "Men's Football"
    }
  },
  match: {
    home: {
      button_text: 'Registration'
    },
    registration: {
      button_text: 'Submit',
      button_update_text: 'Update'
    },
    personSuccess: {
      text_1: 'Registration Successful',
      text_update_1: 'Registration Updated Successfully',
      text_2: 'modify registration',
      text_3: 'Event Homepage',
      text_4: 'Access'
    },
    homeTabs: {
      text_1: 'Standings',
      text_2: 'Schedule',
      text_3: 'Team Data',
      text_4: 'Player Rank',
      text_5: 'Ranking',
      text_6: 'Member List',
      text_7: 'Not Announced',
      text_8: 'Personal Statistics',
      text_9: 'More',
      "得分王": 'Points',
      "助攻王": 'Assists',
      "篮板王": 'Rebounds',
      "盖帽王": 'Blocks',
      "抢断王": 'Steals'
    },
    standings: {
      text_1: 'MP',
      text_2: 'W',
      text_3: 'D',
      text_4: 'L',
      text_5: 'GD',
      text_6: 'Pts',
      text_7: 'WR',
      text_8: 'PPG',
      text_9: 'PA<br>PG',
      text_10: 'PD<br>PG',
      text_11: 'GD',
      text_12: 'PD'
    },
    schedule: {
      text_1: 'Pending start',
      text_2: 'Live',
      text_3: 'Full time',
      text_4: 'Video Recording'
    },
    playerList: {
      text_1: 'GS',
      text_2: 'Cards',
      text_3: 'AST',
      text_4: 'Player',
      text_5: 'Team',
      text_6: 'Goal',
      text_7: 'RC',
      text_8: 'YC',
      text_9: 'Assist',
      text_10: 'PG',
      text_11: 'MP',
      text_12: 'REB',
      text_13: 'STL',
      text_14: 'BLK',
      text_15: 'PTS',
      text_16: 'AST'
    }
  },
  event: {
    activity: {
      text_1: 'Match Time',
      text_2: 'Sport Type',
      text_3: 'Match Address',
      text_4: 'Video Highlights',
      text_5: 'More',
      text_6: 'Match Statistics',
      text_7: 'Team',
      text_8: 'Total'
    }
  },
  attendMatchPlayer: {
    text_1: 'Member List',
  },
  livePage: {
    highlights: 'Highlights',
    commentTab: 'Comment',
    all: 'All',
    noVideo: 'No data',
    allComments: 'All',
    noComment: 'No comments',
    playing: 'Playing',
    commentDisabledLine1: '暂未开通评论',
    commentDisabledLine2: 'Comments are disabled',
    interactionDisabledLine1: 'Interaction is disabled',
    interactionDisabledLine2: 'Likes and comments are unavailable',
    dialogConfirm: 'OK',
    commentPopupTitle: 'Comment',
    commentCancel: 'Cancel',
    commentSubmit: 'Post',
    commentPlaceholder: 'Say something...',
    commentEmpty: 'Please enter a comment',
    commentSendOk: 'Sent'
  }
}
